import { NoFocusButton } from 'components/CommonComponents/NoFocusButton'
import { RootState } from 'constants/interfaces'
import { Plus } from 'lucide-react'
import { BoxProps, ButtonProps, Text } from '@chakra-ui/core'
import React from 'react'
import { useSelector } from 'react-redux'

interface OpenModalTriggerProps extends Omit<ButtonProps, 'children'> {
  onCreate: () => void
  createButtonText: string
  icon?: React.ReactNode
  textProps?: BoxProps
}

export const OpenModalTrigger: React.FC<OpenModalTriggerProps> = ({
  onCreate,
  createButtonText,
  icon,
  textProps,
  ...props
}) => {
  const theme = useSelector((state: RootState) => state.general.theme)
  return (
    <NoFocusButton
      w="max-content"
      maxWidth="150px"
      bg={theme?.elementsColor}
      color="white"
      borderRadius="5px"
      variant="outline"
      background={theme?.elementsColor}
      onClick={onCreate}
      display={{ base: 'none', md: 'flex' }}
      style={{ gap: '5px' }}
      _hover={{ opacity: 0.8 }}
      {...props}
    >
      <Text fontSize="14px" display={{ base: 'none', md: 'block' }} {...textProps}>
        {createButtonText}
      </Text>
      {icon || <Plus size={16} />}
    </NoFocusButton>
  )
}
